<template>
    <div class="contentbox">
      <div class="toptitle">
        <!--<router-link class="w" tag="span" to="/guidePage">&lt;</router-link>-->
        <div></div>
        <div class="other w">
          <i  v-show="!state" @click="showsearchbox" class="el-icon-search"></i>
          <div v-show="state">
            <el-input placeholder="請輸入內容" @keyup.enter.native="onsearch" v-model="searchvalue" class="input-with-select">
              <el-button @click="onsearch" slot="append" icon="el-icon-search"></el-button>
              <el-button @click="showsearchbox" slot="append" icon="el-icon-close"></el-button>
            </el-input>
          </div>
          <span v-show="!state" class="personalicon" @click="reopenNewOrder">
          <img src="../assets/images/add.png" alt="">
        </span>
          <div v-show="!state" class="pcshow" @click="inorderlist">
            <img src="../assets/images/chat.png" alt="">
          </div>
          <!--<div v-show="!state" class="pcshow" @click="toCart">-->
            <!--<img src="../assets/images/chat1.png" alt="">-->
          <!--</div>-->
          <div v-show="!state" class="personalicon" @click="showPersonalCenter">
            <img src="../assets/images/personal.png" alt="">
          </div>
        </div>
      </div>
      <mt-popup
        v-model="popupVisible"
        :modal="false"
        position="right">
        <slot>
          <div class="PersonalCenter">
            <h1>个人中心</h1>
            <div>公司名称({{$store.state.loginuserdata.enterprise}})</div>
            <div>用户名称({{$store.state.loginuserdata.username}})</div>
            <div><mt-button @click="curtainlogout" type="danger">退出</mt-button></div>
            <div><mt-button @click="showPersonalCenter" type="primary">返回</mt-button></div>
          </div>
        </slot>
      </mt-popup>
      <div class="classbox">
        <!--一級分類-->
        <ul class="tab tab1" v-show="show_classify" :class="classify.length === 4?'num4':classify.length > 4?'num5':''">
          <li :data-id="itme.pro_classify_id"
              v-for="(itme,index) in classify"
              @click="onclickclass"
              :key="index"
              :class="index===0?'active':''">
            <img :data-id="itme.pro_classify_id" :src="itme.ecst_class_pic" alt="">
            {{itme.pro_classify_name}}
          </li>
        </ul>
        <!--二級分類-->
        <ul class="tab tab2"
            :class="childclassify.length === 4?'num4':childclassify.length > 4?'num5':''"
            v-show="show_childclassify">
          <li :data-id="itme.pro_classify_id"
              v-for="(itme,index) in childclassify"
              @click="onclickclass2"
              :key="index">
            <img :data-id="itme.pro_classify_id" :src="itme.ecst_class_pic" alt="">
            {{itme.pro_classify_name}}
          </li>
        </ul>
        <!--三級分類-->
        <ul class="tab tab3"
            :class="childclassify3.length === 4?'num4':childclassify3.length > 4?'num5':''"
            v-show="show_childclassify3">
          <li :data-id="itme.pro_classify_id"
              v-for="(itme,index) in childclassify3"
              @click="onclickclass3"
              :key="index">
            <img :data-id="itme.pro_classify_id" :src="itme.ecst_class_pic" alt="">
            {{itme.pro_classify_name}}
          </li>
        </ul>
      </div>
      <!--产品-->
      <ul class="commodity" v-show="show_prodetail">
        <li :key="index" v-for="(itme,index) in prodetail"
            @click="onselect(itme.expend_id,itme.subproduct,itme.product_id)">
          <img :src="itme.product_img"/>
          <p>{{itme.product_name}}</p>
          <p>
            {{itme.currency_symbol}}
            <span v-if="itme.expend_price>0">{{itme.expend_price}}</span>
            <span v-if="itme.expend_price<=0">{{itme.price_scope}}</span>
          </p>
        </li>
      </ul>
      <div class="prompt_information" v-show="show_prodetail && !prodetail.length">
        <div>此分類沒有產品</div>
        <el-button @click="back_class" type="primary">确定</el-button>
      </div>

    </div>
</template>

<script>
  import {getProClassify,curtainlogout,cancelReserve} from '../assets/js/api'
  import {traditionalized} from '../assets/js/language'
  import ScrollPosition from '../assets/js/scroll-position'
  import {Popup, MessageBox } from 'mint-ui'
    export default {
        name: "commodity",
        data(){
          return{
            searchvalue:'',
            popupVisible:false,
            state:false,
            classify:{},
            childclassify:[],
            childclassify3:[],
            show_classify:true,
            show_childclassify:false,
            show_childclassify3:false,
            show_prodetail:false,
            prodetail:[],
            searchprodetail:[],
            pid:'',
            pid2:'',
            class_list_margin:'0',
          }
        },
        components:{
          Popup,
          MessageBox,
        },
        mounted(){
          getProClassify().then((data)=>{
            // this.prodetail = this.classify.filter((item)=>{
            //   return item.pro_classify_id === e.target.getAttribute('data-id')
            // })
            this.pid = data.data[0].pro_classify_id
            this.childclassify = data.data[0].child
            this.prodetail = data.data[0].prodetail
            this.searchprodetail = data.data[0].prodetail
            this.CalculatedHeight()
            this.classify = data.data
            // if (this.classify.length === 4){
            //   this.class_list_margin = '0 40%'
            // }

          })

          ScrollPosition.get.call(this);
        },
        methods:{
          // 跳转到购物车
          toCart(){
            this.$router.push({ path: '/shoppingcart'});
          },
          CalculatedHeight(){
            setTimeout(()=>{
              let h = document.getElementsByClassName('classbox')[0].clientHeight
              document.getElementsByClassName('commodity')[0].style.marginTop = `${h}px`
            })
          },
          onselect(id,subproduct,product_id,classify_id){
            if (subproduct>0){
              this.$router.push({ path: '/seletcattribute?id='+product_id});
            }
            else {
              this.$router.push({ path: '/commodity?id='+id+'&product_id='+product_id+'&classify_id='+classify_id});
              // this.$router.push({ path: '/shop?id='+id+'&product_id='+product_id});
            }
          },
          showsearchbox(){
           if (this.state){
             this.state = false
           }
           else {
             this.state = true
           }
          },
          reopenNewOrder(){
            sessionStorage.removeItem('LocalShoppingCart');
            sessionStorage.removeItem('order_id');
            sessionStorage.removeItem('quotation_code');
            this.$store.commit('res_state')
            this.$router.push({ path: '/index'});
          },
          onclickclass(e){
            Array.from(document.getElementsByClassName('tab')[0].children).forEach(function (v) {
              v.className = ''
            })
            e.target.className= 'active'

            //再次点击主分类时清除子分类的选中
            if (document.getElementsByClassName('tab2')[0] !== undefined){
              Array.from(document.getElementsByClassName('tab2')[0].children).forEach(function (v) {
                v.className = ''
              })
            }
            if (document.getElementsByClassName('tab3')[0] !== undefined){
              Array.from(document.getElementsByClassName('tab3')[0].children).forEach(function (v) {
                v.className = ''
              })
            }


            this.pid = e.target.getAttribute('data-id')
            this.prodetail = this.classify.filter((item)=>{
              return item.pro_classify_id === e.target.getAttribute('data-id')
            })
            this.childclassify = this.prodetail[0].child //显示第一个分类下的子分类
            this.prodetail = this.prodetail[0].prodetail //默认显示第一个分类下的数据

            this.searchprodetail = this.prodetail //搜索數據
            this.CalculatedHeight()
            this.show_classify = false
            if (this.childclassify.length){
              this.show_childclassify = true
            }
            else {
              this.show_prodetail = true
            }
            if (this.prodetail.length){
              //沒有子分類後，且有產品時直接進入第一個產品的詳情頁面
              this.onselect(this.prodetail[0].expend_id,this.prodetail[0].subproduct,this.prodetail[0].product_id,e.target.getAttribute('data-id'))
            }
          },
          onclickclass2(e){
            this.pid2 = e.target.getAttribute('data-id')
            Array.from(document.getElementsByClassName('tab2')[0].children).forEach(function (v) {
              v.className = ''
            })
            e.target.className= 'active'
            if (document.getElementsByClassName('tab3')[0] !== undefined){
              Array.from(document.getElementsByClassName('tab3')[0].children).forEach(function (v) {
                v.className = ''
              })
            }

            this.classify.map((item)=>{
              if (item.pro_classify_id === this.pid) {
                this.prodetail = item.child.filter(itme2=>{
                  return itme2.pro_classify_id === e.target.getAttribute('data-id')
                })
              }
            })
            this.childclassify3 = this.prodetail[0].child //显示第三级分类
            this.prodetail = this.prodetail[0].prodetail //二级分类下的产品数据
            this.searchprodetail = this.prodetail //更新搜索数据
            this.CalculatedHeight()

            this.show_childclassify = false
            if (this.childclassify3.length){
              this.show_childclassify3 = true
            }
            else {
              this.show_prodetail = true
            }
            if (this.prodetail.length){
              //沒有子分類後，且有產品時直接進入第一個產品的詳情頁面
              this.onselect(this.prodetail[0].expend_id,this.prodetail[0].subproduct,this.prodetail[0].product_id,e.target.getAttribute('data-id'))
            }
          },
          onclickclass3(e){
            Array.from(document.getElementsByClassName('tab3')[0].children).forEach(function (v) {
              v.className = ''
            })
            e.target.className= 'active'
            this.classify.map((item)=>{
              if (item.pro_classify_id === this.pid) {
                item.child.map(itme2=>{
                  if (itme2.pro_classify_id === this.pid2) {
                    this.prodetail = itme2.child.filter(itme3=>{
                      return itme3.pro_classify_id === e.target.getAttribute('data-id')
                    })
                  }
                })
              }
            })
            this.prodetail = this.prodetail[0].prodetail //二级分类下的产品数据
            this.searchprodetail = this.prodetail //更新搜索数据
            if (this.prodetail.length){
              //沒有子分類後，且有產品時直接進入第一個產品的詳情頁面
              this.onselect(this.prodetail[0].expend_id,this.prodetail[0].subproduct,this.prodetail[0].product_id,e.target.getAttribute('data-id'))
            }
          },
          onsearch(){
            let newprodetail = []
            for (let key in  this.searchprodetail) {
              if (traditionalized( this.searchprodetail[key].product_name).indexOf(traditionalized(this.searchvalue)) !== -1){
                newprodetail.push( this.searchprodetail[key])
              }
            }
            this.prodetail = newprodetail
            // this.prodetail = this.prodetail.filter((itme)=>{
            //   return itme.product_name.indexOf(this.searchvalue) === 0
            // })
          },
          showPersonalCenter(){
            this.popupVisible ? this.popupVisible = false : this.popupVisible = true
          },
          curtainlogout(){
            curtainlogout().then(data=>{
              sessionStorage.removeItem('LocalShoppingCart');
              sessionStorage.removeItem('order_id');
              localStorage.removeItem('logindata');
              localStorage.removeItem('userdata');
              this.$store.commit('res_state')
              this.$router.push({ path: '/'});
            })
          },
          inorderlist(){
            this.$store.commit('set_inorderilstroutername','commodity')
            this.$router.push({ path: '/orderlist'});
          },
          back_class(){
            this.show_classify = true
            this.show_childclassify = false
            this.show_childclassify3 = false
            this.show_prodetail = false
          }
        },
      computed: {

      },
    }
</script>

<style scoped lang="less">
  @import "../assets/less/base";
  .contentbox{
    /*position: relative;*/
    width: 100%;
    .toptitle{
      position: fixed;
      z-index: 1;
      width: 80%;
      background-color: @maincolor;
      height: 52px;
      line-height: 52px;
      color: #fff;
      padding: 0 10%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .w{
        width: 50%;
        display: flex;
        align-items: center;
        justify-content: start;
        >i{
          font-size: 30px;
          cursor: pointer;
        }
      }
      .other{
        justify-content: flex-end;
      }
      img{
        height: 46px;
      }
      .pcshow{
        @media (min-width: @screen-xs-max) {
          display: block !important;
        }
      }
      .personalicon{
        @media (min-width: @screen-xs-max) {
          display: block !important;
        }
        img{
          height: 32px;
        }
      }
      >span{
        font-size: 40px;
        cursor: pointer;
      }
      >div{
        /*width: 80%;*/
        transition: all 1s;
        /*margin-left: -100px;*/
        cursor: pointer;
      }

    }
    .PersonalCenter{
      background-color: #fff;
      height: 100vh;
      width: 100vw;
      padding-top: 30%;
      text-align: center;
      h1{
        margin: 30px auto;
        font-size: 0.5rem;
      }
      div{
        font-size: 0.3rem;
        margin-top: 30px;
      }
    }
    .classbox{
      background: #fff;
      /*position: fixed;*/
      margin-top: 100px;
      width: 100%;
      ul.tab{
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: space-around;
        margin: 0 auto;
        padding-bottom: 50px;
        &.num4{
          li{
            margin: 20px 10%;
          }
        }
        &.num5{
          li{
            margin: 20px 8%;
          }
        }
        li{
          width: 15vw;
          height: 15vw;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          /*border: 1px solid #00ffff;*/
          /*border-radius: 50%;*/
          cursor: pointer;
          font-size: 0.5rem;
          img{
            max-width: 100%;
          }
        }
        li:hover{
          /*background: #3a8ee6;*/
          /*color: #fff;*/
          /*transition: all 0.5s;*/
        }
        li.active{
          /*border-bottom: 2px solid #000;*/
          /*color: #000;*/
        }
      }
      ul.tab1{
        li{

        }
      }
      ul.tab2{
      }
      ul.tab3{
      }
    }

    ul.commodity{
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;
      width: 96%;
      margin: 3.2rem auto 0.2rem auto;
      li{
        width: 41%;
        /*height: 90px;*/
        cursor: pointer;
        margin-top: 8px;
        padding: 0.2rem;
        box-shadow: 0px 2px 5px 2px #e8e8e8;
        margin-left: 2%;
        @media (min-width: @screen-xs-max) {
          width: 21%;
        }
        img{
          width: 100%;
        }
        p{
          margin-top: 0.1rem;
          font-size: 14px;
        }
      }
    }
    .prompt_information{
      display: flex;
      align-items: center;
      justify-items: center;
      flex-direction: column;
      >div{
        margin: 50px 0;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/index.vue